var _path, _text;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgComingSoon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 107.083,
    height: 78.384
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.02 51.957c12.289-9.204 20.79-48.172-8.43-42.456S29.484 10.612 8.257 30.333 33.79 84.083 44.97 66.686s36.756-5.523 49.048-14.729z",
    fill: "#1ba9b6"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "rotate(-16 173.055 -176.1)",
    fill: "#fff",
    fontSize: 15,
    fontFamily: "Nunito-Regular,Nunito,sans-serif"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -31.297,
    y: 0
  }, "Em breve"))));
}

export default SvgComingSoon;